export const SONGSTYLE = [
  {
    name: "全部歌单",
    type: "One",
  },
  {
    name: "华语",
    type: "Two",
  },
  {
    name: "欧美",
    type: "Three",
  },
  {
    name: "日本",
    type: "Four",
  },
  {
    name: "❤纯欲风❤",
    type: "Five",
  },
];

export const enum SongListSource {
  UserCollection = "userCollection",
  UserSongList = "userSongList",
  Other = "other",
}
